import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e89ad29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dv-question-title" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "dv-title-index"
}
const _hoisted_4 = {
  key: 1,
  class: "dv-title-score"
}
const _hoisted_5 = { class: "div-options" }

import { computed, onActivated, ref } from "vue";
import useCompileContent from "@/hooks/useCompileContent";
import ChoiceQuestion from "@/components/ChoiceQuestion.vue";
import MultipleQuestion from "@/components/MultipleQuestion.vue";
import TrueOrFalseQuestion from "@/components/TrueOrFalseQuestion.vue";
import SheetMusicCreation from "@/components/SheetMusicCreation.vue";
import SheetMusicSing from "@/components/SheetMusicSing.vue";
import SheetMusicSong from "@/components/SheetMusicSong.vue";
import BriefAnswerQuestion from "@/components/BriefAnswerQuestion.vue";
import FillsInQuestion from "@/components/FillsInQuestion.vue";
import ConnectQuestion from "@/components/ConnectQuestion.vue";
import JigsawQuestion from "@/components/JigsawQuestion.vue";
import DragQuestion from "@/components/DragQuestion.vue";
import ColorWheelQuestion from "@/components/ColorWheelQuestion.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  question: {
    type: Object,
  },
  disabled: {
    type: Boolean,
  },
  showQuestionNum: {
    type: Boolean,
    default: true,
  },
  showQuestionScore: {
    type: Boolean,
    default: true,
  },
},
  emits: ["error"],
  setup(__props, { expose, emit: emits }) {

const props = __props




const { compileQuestionTitle } = useCompileContent();

const question = ref(props.question || {});
console.log("taoti", question.value);
const { sub_questions = [] } = question.value;
const subQuestionIndex = ref(0);
const subQuestionRef = ref<any>({});
let subQuestion = ref<any>({});
// if (question.value.indexInQuestion) {
console.log(123);
subQuestion = computed(() => ({
  ...(sub_questions[subQuestionIndex.value] || {}),
  indexInQuestion: question.value.indexInQuestion,
  titleNum: subQuestionIndex.value + 1,
  // titleNum:
  //   question.value.indexInQuestion +
  //   "." +
  //   (subQuestionIndex.value + 1).toString(),
}));
// } else {
//   console.log(456);
//   subQuestion = computed(() => ({
//     ...(sub_questions[subQuestionIndex.value] || {}),
//     indexInQuestion: subQuestionIndex.value + 1,
//     titleNum: subQuestionIndex.value + 1,
//   }));
// }
// subQuestion = computed(() => ({
//   ...(sub_questions[subQuestionIndex.value] || {}),
//   indexInQuestion: subQuestionIndex.value + 1,
//   titleNum:
//     question.value.indexInQuestion +
//     "." +
//     (subQuestionIndex.value + 1).toString(),
// }));

const getAnswer = async () => {
  const subAnswer = await subQuestionRef.value.getAnswer();
  if (subAnswer.type === 0) {
    return subAnswer;
  }
  return {
    type: 1,
    answer_params: {
      parentId: question.value.id,
      questionId: subQuestion.value.id,
      answer: subAnswer,
    },
  };
};

const changeSubQuestion = (direction: "previous" | "next") => {
  const subQuestionLength = sub_questions.length;
  let featureSubQuestionIndex = subQuestionIndex.value;
  if (direction == "previous") {
    featureSubQuestionIndex -= 1;
  } else {
    featureSubQuestionIndex += 1;
  }
  if (
    featureSubQuestionIndex < 0 ||
    featureSubQuestionIndex >= subQuestionLength
  ) {
    return false;
  }
  subQuestionIndex.value = featureSubQuestionIndex;
  return true;
};

const isFirstSubQuestion = () => {
  return subQuestionIndex.value === 0;
};
const isLastSubQuestion = () => {
  return subQuestionIndex.value === sub_questions.length - 1;
};

// * 标题编译
const questionTitle = ref<HTMLDivElement>();
compileQuestionTitle(questionTitle, question.value.title || "");

// 组件内部报错抛出异常
const onError = (e: any) => {
  emits("error", e);
};

const onResetSheet = () => {
  // console.log("question", question);
  sub_questions[subQuestionIndex.value].answer_params = undefined;
  sub_questions[subQuestionIndex.value].answerScore = 0;
};
expose({
  getAnswer,
  changeSubQuestion,
  isFirstSubQuestion,
  isLastSubQuestion,
});

onActivated(() => {
  const subIndex = subQuestionIndex.value;
  subQuestionIndex.value = -1;
  setTimeout(() => {
    subQuestionIndex.value = subIndex;
  }, 0);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.showQuestionNum)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(question.value.indexInQuestion) + ". ", 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        id: "nestingTitle",
        class: "dv-title",
        ref_key: "questionTitle",
        ref: questionTitle
      }, null, 512),
      (props.showQuestionScore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " (" + _toDisplayString(question.value.score) + "分) ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_unref(subQuestion).type === 1)
        ? (_openBlock(), _createBlock(ChoiceQuestion, {
            key: _unref(subQuestion).id,
            question: _unref(subQuestion),
            disabled: props.disabled,
            showQuestionScore: __props.showQuestionNum,
            ref_key: "subQuestionRef",
            ref: subQuestionRef
          }, null, 8, ["question", "disabled", "showQuestionScore"]))
        : _createCommentVNode("", true),
      (_unref(subQuestion).type === 2)
        ? (_openBlock(), _createBlock(MultipleQuestion, {
            key: _unref(subQuestion).id,
            question: _unref(subQuestion),
            disabled: props.disabled,
            showQuestionScore: __props.showQuestionNum,
            ref_key: "subQuestionRef",
            ref: subQuestionRef
          }, null, 8, ["question", "disabled", "showQuestionScore"]))
        : _createCommentVNode("", true),
      (_unref(subQuestion).type === 3)
        ? (_openBlock(), _createBlock(SheetMusicCreation, {
            key: _unref(subQuestion).id,
            question: _unref(subQuestion),
            disabled: props.disabled,
            showQuestionScore: __props.showQuestionNum,
            ref_key: "subQuestionRef",
            ref: subQuestionRef,
            onError: onError,
            "upload-proctor": true,
            onResetSheet: onResetSheet
          }, null, 8, ["question", "disabled", "showQuestionScore"]))
        : _createCommentVNode("", true),
      (_unref(subQuestion).type === 4)
        ? (_openBlock(), _createBlock(TrueOrFalseQuestion, {
            key: _unref(subQuestion).id,
            question: _unref(subQuestion),
            disabled: props.disabled,
            showQuestionScore: __props.showQuestionNum,
            ref_key: "subQuestionRef",
            ref: subQuestionRef
          }, null, 8, ["question", "disabled", "showQuestionScore"]))
        : _createCommentVNode("", true),
      ([5, 6].includes(_unref(subQuestion).type))
        ? (_openBlock(), _createBlock(SheetMusicSong, {
            key: _unref(subQuestion).id,
            question: _unref(subQuestion),
            disabled: props.disabled,
            showQuestionScore: __props.showQuestionNum,
            ref_key: "subQuestionRef",
            ref: subQuestionRef,
            onError: onError,
            "upload-proctor": true
          }, null, 8, ["question", "disabled", "showQuestionScore"]))
        : _createCommentVNode("", true),
      (_unref(subQuestion).type === 7)
        ? (_openBlock(), _createBlock(SheetMusicSing, {
            key: _unref(subQuestion).id,
            question: _unref(subQuestion),
            disabled: props.disabled,
            showQuestionScore: __props.showQuestionNum,
            ref_key: "subQuestionRef",
            ref: subQuestionRef,
            onError: onError,
            "upload-proctor": true
          }, null, 8, ["question", "disabled", "showQuestionScore"]))
        : _createCommentVNode("", true),
      (_unref(subQuestion).type === 8)
        ? (_openBlock(), _createBlock(ConnectQuestion, {
            key: _unref(subQuestion).id,
            question: _unref(subQuestion),
            disabled: props.disabled,
            showQuestionScore: __props.showQuestionNum,
            ref_key: "subQuestionRef",
            ref: subQuestionRef
          }, null, 8, ["question", "disabled", "showQuestionScore"]))
        : _createCommentVNode("", true),
      (_unref(subQuestion).type === 9)
        ? (_openBlock(), _createBlock(FillsInQuestion, {
            key: _unref(subQuestion).id,
            question: _unref(subQuestion),
            disabled: props.disabled,
            showQuestionScore: __props.showQuestionNum,
            ref_key: "subQuestionRef",
            ref: subQuestionRef
          }, null, 8, ["question", "disabled", "showQuestionScore"]))
        : _createCommentVNode("", true),
      (_unref(subQuestion).type === 10)
        ? (_openBlock(), _createBlock(BriefAnswerQuestion, {
            key: _unref(subQuestion).id,
            question: _unref(subQuestion),
            disabled: props.disabled,
            showQuestionScore: __props.showQuestionNum,
            ref_key: "subQuestionRef",
            ref: subQuestionRef
          }, null, 8, ["question", "disabled", "showQuestionScore"]))
        : _createCommentVNode("", true),
      (_unref(subQuestion).type === 12)
        ? (_openBlock(), _createBlock(DragQuestion, {
            key: _unref(subQuestion).id,
            question: _unref(subQuestion),
            disabled: props.disabled,
            showQuestionScore: __props.showQuestionNum,
            ref_key: "subQuestionRef",
            ref: subQuestionRef
          }, null, 8, ["question", "disabled", "showQuestionScore"]))
        : _createCommentVNode("", true),
      (_unref(subQuestion).type === 13)
        ? (_openBlock(), _createBlock(ColorWheelQuestion, {
            key: _unref(subQuestion).id,
            question: _unref(subQuestion),
            disabled: props.disabled,
            showQuestionScore: __props.showQuestionNum,
            ref_key: "subQuestionRef",
            ref: subQuestionRef
          }, null, 8, ["question", "disabled", "showQuestionScore"]))
        : _createCommentVNode("", true),
      (_unref(subQuestion).type === 14)
        ? (_openBlock(), _createBlock(JigsawQuestion, {
            key: _unref(subQuestion).id,
            question: _unref(subQuestion),
            disabled: props.disabled,
            showQuestionScore: __props.showQuestionNum,
            ref_key: "subQuestionRef",
            ref: subQuestionRef
          }, null, 8, ["question", "disabled", "showQuestionScore"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})